import { useMutation } from '@tanstack/react-query';

import { authenticateWithTelegram } from '../api/authApi';

export function useTelegramAuth() {
  return useMutation({
    mutationFn: authenticateWithTelegram,
  });
}
